import { getAutoModeApplicationInputs } from './ApplicationRequirements/useApplicationFieldRequirements'
import { getAutoModeRoleInputs } from './DirectoryRoleRequirements/useRoleFieldRequirements'
import { getAutoModeGroupInputs } from './GroupRequirements/useGroupFieldRequirements'
import { getAutoModeNamedLocationInputs } from './NamedLocationRequirements/useNamedLocationFieldRequirements'
import { getAutoModeUserInputs } from './UserRequirements/useUserFieldRequirements'

// A group/named-location/application/user/directory-role field resolved via an attached
// requirement isn't manually prompted at deploy, so it's deliberately absent from the template's
// own stored `promptedInputs` (see PolicyTemplateDetailsModal's own setup) — passing that raw,
// stored list straight through always shows "None" for "Automatically resolved" and omits the
// field entirely, even though the template's own edit view computes and shows it correctly. This
// mirrors that same computation so every read-only view of a saved template matches the edit view.
const getDisplayPromptedInputs = (template) => {
  const policyBody = template?.meta_data?.policyBody
  const storedPromptedInputs = template?.meta_data?.promptedInputs ?? []

  const requiredByInput = Object.fromEntries(storedPromptedInputs.map((input) => [input.name, input.required]))

  const autoResolvedInputs = new Set([
    ...getAutoModeGroupInputs(policyBody),
    ...getAutoModeNamedLocationInputs(policyBody),
    ...getAutoModeApplicationInputs(policyBody),
    ...getAutoModeUserInputs(policyBody),
    ...getAutoModeRoleInputs(policyBody),
  ])

  const inputNames = new Set([...storedPromptedInputs.map((input) => input.name), ...autoResolvedInputs])

  return Array.from(inputNames).map((name) => ({
    name,
    required: requiredByInput[name],
    autoResolved: autoResolvedInputs.has(name),
  }))
}

export default getDisplayPromptedInputs
